<template>
    <div>
        <div class="count_section">
            <p class="count_text">Кол-во: {{ animes_count }}</p>
        </div>
    </div>
</template>

<script>

export default {
    props:{
        animes_count:{
            required: true
        }
    }
}
</script>

<style>

.count_section{
    margin-left: 40px;
}
.count_text{
    font-family: 'Montserrat';
    margin-bottom: 0;
}

@media only screen and (max-width: 768px) {
    .count_section{
        margin-left: 20px;
    }

}
</style>